import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import style from './style.css'

export default function TopBar (props) {
  return (
    <div
      {...(props.headerStyle !== 'achieve' ? { role: 'banner' } : {})}
      className={classnames(style.container, {
        [style.containerPreview]: props.isPreview,
        [style.achieveHeader]: props.headerStyle === 'achieve',
        [style.achieveFaq]: props.faqStyle,
        [style.achieveAlignRight]: props.achieveAlignRight
      })}
    >
      {props.children}
    </div>
  )
}

TopBar.propTypes = {
  children: PropTypes.node.isRequired,
  splitPane: PropTypes.bool,
  isPreview: PropTypes.bool,
  headerStyle: PropTypes.string,
  faqStyle: PropTypes.bool,
  achieveAlignRight: PropTypes.bool
}
